import cloneDeep from 'lodash/cloneDeep'
import unescape from 'lodash/unescape'
import { AccountTypes } from '@/constants/user/accountTypes'
import Skill from '@/models-ts/Skill'
import Avatar from '@/models-ts/user/Avatar'
import { parseSlug } from '@/utils/parser'

export default class LandingGig {
  id: string | number
  slug: string
  name: string
  rate: string
  time_type: number // typeof TIME_FIXED | typeof TIME_HOURLY
  user: {
    id: string | number
    type: AccountTypes
    avatar: Avatar
    name: string
    rating: number
    reviewCount: number
  }
  skills: Array<Skill>

  constructor(data: Partial<LandingGig>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.LandingGig) {
    return new LandingGig({
      id: data.id,
      slug: parseSlug(data.slug),
      name: unescape(data.name),
      rate: data.rate,
      time_type: +data.time_type,
      user: {
        id: data.relations.Freelancer.id,
        type: data.relations.Freelancer.type,
        name: unescape(data.relations.Freelancer.name),
        avatar: Avatar.fromServer(data.relations.Freelancer.avatar),
        rating: data.relations.Freelancer.profile.avg_reviews,
        reviewCount: data.relations.Freelancer.reviews_count,
      },
      skills: (data.relations.Skill || []).map(Skill.fromServer),
    })
  }
}
